import { Svg } from 'components/svg'
import type { IconType } from 'models.d'

export const IconArrow: IconType = ({ className = '', ...props }) => (
  <Svg
    {...props}
    className={className}
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30.1934 37.1614L14.7095 24.0002L30.1934 10.8389"
      strokeLinecap="round"
      strokeLinejoin="round"
      stroke="currentColor"
    />
  </Svg>
)
